// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__prj5O","header":"MessagesList_header__3IP8J","chat":"MessagesList_chat__2VD27"};